import { styled } from '@mui/material';
import { theme } from '@/theme.tsx';

export const Container = styled('div')`
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
`;

export const FallbackContainer = styled('div')`
  background-color: ${theme.palette.primary.main};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
